export { default as CardPrimaryBadge } from './CardPrimaryBadge';
